module.exports = __webpack_public_path__ + "servicios1.a5653368fe3d8a84fc36.png";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/servicios1.png
// module id = ../../../../../src/assets/images/servicios1.png
// module chunks = 1